import React from 'react';
import PropTypes from 'prop-types';

const EnhancedAdButton = props => {
  const generateButtonClass = () => {
    if (props.creativeValid()) {
      return 'enhanced-ad_generate-button enhanced-ad_generate-button--active';
    } else {
      return 'enhanced-ad_generate-button enhanced-ad_generate-button--inactive';
    }
  };

  const buttonText = () => {
    if (!props.creative.id && props.creative.dsp.rtb_version === '2.3') {
      return 'Generate Pixel';
    } else {
      return 'Save';
    }
  };

  return (
    <div
      onClick={props.onClick}
      className={generateButtonClass()}
      role="presentation"
    >
      {buttonText()}
    </div>
  );
};

EnhancedAdButton.propTypes = {
  creative: PropTypes.shape({
    id: PropTypes.number,
    dsp: PropTypes.shape({
      rtb_version: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  creativeValid: PropTypes.func.isRequired
};

export default EnhancedAdButton;
